<template>
  <!-- 角色管理 -->
  <div class="page">
    <div class="paginations" :style="{ filter: this.$store.state.isVague ? 'blur(2px)' : '' }">
      <div class="table-search-box table-search-box-hander">
        <el-form :inline="true" :model="searchData" class="demo-form-inline">
          <!-- 防止输入框回车刷新页面 -->
          <el-form-item label="" v-show="false">
            <el-input></el-input>
          </el-form-item>
          <el-form-item label="角色名称：">
            <el-input size="small" v-model="searchData.name" placeholder="请输入角色名称"></el-input>
          </el-form-item>
          <el-form-item>
            <div class="search_button">
              <i class="pointer el-icon-search" @click="search()"></i>
              <i class="pointer el-icon-refresh-left" @click="reset"></i>
            </div>
          </el-form-item>
        </el-form>
        <div class="addition">
          <el-button @click="add">
            添加
            <i class="h_icon icon-add"></i>
          </el-button>
        </div>
      </div>

      <div class="table_box">
        <el-table :data="tableObj.list" style="width: 100%">
          <el-table-column prop="index" label="序号" align='center'>
          </el-table-column>
          <el-table-column prop="name" label="角色名称" align='center'>
          </el-table-column>
          <el-table-column prop="createTime" label="创建时间" align='center'>
          </el-table-column>
          <el-table-column label="是否启用" align='center'>
            <template slot-scope="scope">
              <el-switch v-model="scope.row.status" active-color="#00ffffe5" inactive-color="#1bfaf285"
                @change="changeEnabled($event, scope.row, 'uploadBox.data')">
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" align='center'>
            <template slot-scope="scope">
              <i class="icona icon-distribution_menu" title="分配菜单" @click="menus(scope.row.id)"></i>
              <i class="icona icon-edit" title="编辑" @click="edit(scope.row)"></i>
              <i class="icona icon-delete" title="删除" @click="cutOut(scope.row.id)"></i>
            </template>
          </el-table-column>
        </el-table>
        <pageNumber :paginations="7" :pageNum="searchData.pageDto.pageNum" :pageSize="searchData.pageDto.pageSize"
          :total="tableObj.total" :jumpTo="tableObj.jumpTo" @currentChange="search"></pageNumber>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <el-dialog :title="uploadBox.title" :visible.sync="uploadBox.show" :close-on-click-modal="false" width="600px"
      class="pop_up" append-to-body :before-close="handleClose" @opened="opened">
      <el-form ref="uploadBox" :model="uploadBox.data" :rules="uploadBox.rules" label-width="95px">
        <el-form-item label="名称：" prop="name" required>
          <el-input size="small" v-model="uploadBox.data.name" placeholder="请输入。。。"></el-input>
        </el-form-item>
        <el-form-item label="备注：" prop="description" required>
          <el-input size="small" type="textarea" v-model="uploadBox.data.description" placeholder="请输入。。。"></el-input>
        </el-form-item>
        <el-form-item label="是否启用：" prop="status" required>
          <el-radio-group v-model="uploadBox.data.status">
            <el-radio label="1">启用</el-radio>
            <el-radio label="0">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="tx-center">
        <el-button size="small" @click="submitUpload">确定</el-button>
        <el-button size="small" @click="handleClose">取消</el-button>
      </div>
    </el-dialog>

    <!-- 分配菜单 -->
    <el-dialog :title="specialtyBox.title" :visible.sync="specialtyBox.show" :close-on-click-modal="false" width="600px"
      class="pop_up distribute" append-to-body :before-close="handleClose">
      <div class="specialtySearch">
        <el-input placeholder="请输入菜单快速勾选" v-model="specialtyBox.data.filterText"></el-input>
        <div align="left" style="color: #c0c4cc;">
          <el-checkbox v-model="specialtyBox.data.checked" @change="checkedAll" /> 全选/反选
          <div class="distributionBox">
            <el-tree :data="specialtyBox.data.professionIds" show-checkbox node-key="id" ref="specialtyTree"
              highlight-current default-expand-all :props="specialtyBox.data.defaultProps" :check-strictly="false"
              :filter-node-method="filterNode" @check="handleCheckChange">
            </el-tree>
          </div>
          <div class="tx-center">
            <el-button size="small" @click="specialtySubmitForm">确定</el-button>
            <el-button size="small" @click="handleClose">取消</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import pageNumber from '@/components/pageNumber.vue' //分页

export default {
  components: {
    pageNumber
  },
  data() {
    return {
      searchData: {
        name: '',
        pageDto: {
          pageNum: 1,//当前显示的页面页码数
          pageSize: 10,
        },
      },
      tableObj: {
        total: 0,
        jumpTo: 1,
        list: []
      },




      // 添加弹窗
      uploadBox: {
        show: false,
        title: "添加角色",
        data: {
          id: null,
          name: '',
          description: '',
          status: '1',
        },
        rules: {
          name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
          description: [{ required: true, message: '请填写备注', trigger: 'blur' }],
        },
      },

      // 分配专业弹窗
      specialtyBox: {
        show: false,
        title: "分配专业",
        data: {
          checked: false, //checkbox的值
          filterText: '',
          roleId: null,
          professionIds: [],
          zykIds: [],
          defaultProps: {
            children: 'children',
            label: 'name'
          },
        }
      },
    }
  },
  watch: {
    'specialtyBox.data.filterText'(val) {
      this.$refs.specialtyTree.filter(val);
    }
  },
  created() {
    this.search()
  },
  methods: {
    // 查询表格数据
    search(type) {
      this.searchData.pageDto.pageNum = type ? type : 1
      this.tableObj.jumpTo = type ? type : 1
      this.$axios.post(this.$apiurls.account_getRoleList, this.searchData, {
        loading: false,
      }).then((res) => {
        console.log("查询", res);
        if (res) {
          for (let i = 0; i < res.data.list.length; i++) {
            if (this.searchData.pageDto.pageNum == 1) {
              res.data.list[i].index = i + 1
            } else {
              res.data.list[i].index = i + 1 + ((this.searchData.pageDto.pageNum - 1) * 10)
            }
            res.data.list[i].status = res.data.list[i].status == 0 ? false : true
          }
          this.tableObj.list = res.data.list
          this.tableObj.total = res.data.total
        }
      });
    },
    // 重置表格
    reset() {
      this.searchData.name = ''
      this.search()
    },
    // 过滤树形结构搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
    // 菜单
    menus(id) {
      this.specialtyBox.data.roleId = id
      this.$axios.post(this.$apiurls.account_getRoleBindMenusAndAllMenu, id, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.specialtyBox.show = true
          this.specialtyBox.title = '分配菜单'
          this.specialtyBox.data.professionIds = res.data.allMenuDatas
          this.$store.commit('modifyVague', true);
          this.$nextTick(() => {
            this.$refs.specialtyTree.setCheckedKeys(res.data.bindMenuIds);    //设置默认选中的值
          })
          if (res.data.bindMenuIds.length == this.flat(res.data.allMenuDatas).length) {
            this.specialtyBox.data.checked = true
          } else {
            this.specialtyBox.data.checked = false
          }
        }
      });
    },
    // 选中该菜单时判断是否已经全选或未全选
    handleCheckChange(data, checked) {
      if (checked.checkedKeys.length == this.flat(this.specialtyBox.data.professionIds).length) {
        this.specialtyBox.data.checked = true
      } else {
        this.specialtyBox.data.checked = false
      }
    },
    // 把菜单扁平化一维数组
    flat(arr) {
      return [].concat(...arr.map(item => [].concat(item, ...this.flat(item.children))));
    },
    // 是否全选菜单
    checkedAll() {
      if (this.specialtyBox.data.checked) {
        //全选
        this.$refs.specialtyTree.setCheckedNodes(this.specialtyBox.data.professionIds);
      } else {
        //取消选中
        this.$refs.specialtyTree.setCheckedKeys([]);
      }
    },
    // 确定分配菜单
    specialtySubmitForm() {
      let arr1 = this.$refs.specialtyTree.getCheckedKeys()
      let arr2 = this.$refs.specialtyTree.getHalfCheckedKeys()
      this.$axios.post(this.$apiurls.account_bindRoleMenu, {
        menuIds: [...arr1, ...arr2],
        roleId: this.specialtyBox.data.roleId
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data) {
            this.specialtyBox.show = false
            this.$store.commit('modifyVague', false);
            this.$message({
              message: '分配专业成功！',
              type: 'success'
            });
            this.search()
          } else {
            this.$message.error(res.message)
          }
        }
      });
    },
    // 编辑
    edit(row) {
      this.uploadBox.show = true
      this.$store.commit('modifyVague', true);
      this.uploadBox.data.id = row.id
      this.uploadBox.data.name = row.name
      this.uploadBox.data.description = row.description
      this.uploadBox.data.status = row.status ? '1' : '0'
    },
    // 删除
    cutOut(id) {
      this.$store.commit('modifyVague', true);
      this.$confirm('此操作将永久删除该角色, 是否继续?', '删除提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        this.$axios.post(this.$apiurls.account_deleteRoleInfo, id, {
          loading: false,
        }).then((res) => {
          if (res) {
            if (res.data) {
              this.$message({
                message: '删除成功！',
                type: 'success'
              });
              this.search()
            } else {
              this.$message.error('删除失败！')
            }
          }
          this.uploadBox.show = false
          this.$store.commit('modifyVague', false);
        });
      }).catch(() => {
        this.uploadBox.show = false
        this.$store.commit('modifyVague', false);
      });
    },
    // 是否启用
    changeEnabled(value, row) {
      this.uploadBox.data = row
      this.uploadBox.data.status = row.status ? '1' : '0'
      this.uploadBox.data.enabled = row.enabled ? '1' : '0'
      this.$axios.post(this.$apiurls.account_saveOrUpdateRoleInfo, this.uploadBox.data, {
        loading: false,
      }).then((res) => {
        if (res) {
          if (res.data) {
            this.$message({
              message: !value ? '关闭成功！' : '启用成功！',
              type: 'success'
            });
            this.search()
          }
        }
      });
    },


    // 添加按钮
    add() {
      this.uploadBox.show = true
      this.$store.commit('modifyVague', true);
      this.uploadBox.data = this.$options.data().uploadBox.data
      this.uploadBox.data.id = 0
    },
    // 关闭添加弹窗
    handleClose() {
      this.uploadBox.show = false
      this.specialtyBox.show = false
      this.$store.commit('modifyVague', false);
    },
    // 添加用户
    submitUpload() {
      this.$refs.uploadBox.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apiurls.account_saveOrUpdateRoleInfo, this.uploadBox.data, {
            loading: false,
          }).then((res) => {
            if (res) {
              if (res.data) {
                this.$message({
                  message: this.uploadBox.data.id ? '编辑成功！' : '添加成功！',
                  type: 'success'
                });
                this.search()
              }
              this.uploadBox.show = false
              this.$store.commit('modifyVague', false);
            }
          });
        }
      });
    },
    opened() {
      this.$refs.uploadBox.clearValidate();
    },
  }
}
</script>



<style  lang="scss" src="@/assets/css/popUp.scss" scoped></style>
<style  lang="scss" src="@/assets/css/tableList.scss" scoped></style>
<style lang="scss" scoped>
.addition {
  margin-top: 5px;
}

// 搜索
.table-search-box-hander {
  display: flex;
  justify-content: space-between;
}

.el-form {
  height: 100%;
}

// 分配专业
.distribute ::v-deep .el-dialog__body {
  padding: 10px 20px 20px;
}

.distributionBox {
  max-height: 500px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.specialty_box {
  height: 470px;
  overflow-y: auto;
  // background: #a5a4bf;
  margin-bottom: 60px;
  margin-right: 20px;
}

.specialty_bottom {
  position: absolute;
  bottom: -45px;
  right: 38%;
}

.el-tree,
::v-deep.el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content,
::v-deep.el-tree-node:focus>.el-tree-node__content {
  background: transparent;
  color: #c0c4cc;
}

.el-tree ::v-deep .el-tree-node__content:hover {
  background: #203058 !important;
  color: #fff;
}
</style>
